/**
 * @example
 *  - ['department']
 *  - ['department', 'list', <filters>]
 *  - ['department', 'detail', <id>]
 */
const DepartmentQueryKeys = {
  all: () => ['department'] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...DepartmentQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id?: number) =>
    [
      ...DepartmentQueryKeys.all(),
      'detail',
      ...(id !== undefined ? [id] : [])
    ] as const
};

export default DepartmentQueryKeys;
